import {Component, ViewChild, Input, ElementRef, Renderer2} from '@angular/core';

import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import {TranslateService} from "@ngx-translate/core";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import * as moment from "moment";
import {ExcelWorkService} from "../../../services/excel-work.service";
import {ExportExcelColumn} from "../../../shared/models/export-excel-column";
import {ModuleTableName} from "../../../shared/models/module-table-name";

@Component({
    selector: 'simple-tab',
    templateUrl: './simple-tab.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './simple-tab.component.css']
})
export class SimpleTabComponent extends TabComponentBase<any, { columns: ExportExcelColumn[], mainRows: any[] }> {
    constructor(
        graphService: BufferGraphService,
        exchangeService: BufferGraphDataExchangeService,
        excelService: ExcelWorkService,
        translateService: TranslateService,
        renderer: Renderer2,
        elementRef: ElementRef
    ){

        super(graphService, exchangeService, excelService, translateService, renderer, elementRef);


        //this.dataView.onRowsChanged.subscribe(() => this.setCellCssStyles());
        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };
        this.generateColumns = true;
        this.styleGridCells = true;
        this.dataView = new Slick.Data.DataView<any>();
        this.dataView.onRowsChanged.subscribe(() => this.setMainGridSellStyles());


        // this.helper.wait( () => this.mainRowsSheetName = this.tab.hdr)
    }

    ngOnInit(){
        super.ngOnInit();
        this.gridPropsName = new ModuleTableName('Stocks', this.tab.hdr);
        this.helper.wait( () => this.translateService.get(this.tab.hdr).subscribe(t => this.mainRowsSheetName = t));
    }

    @Input()
    public isActive: boolean;

    @Input()
    private set data(data: any[]) {
        this.dataView.setItems(data);
    }

    // protected sku: string;

    // protected warehouseCode: string;

    @Input()
    public canSend: boolean;

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# download excel
    private onDownloadClick = (): void => {
        const fileName = `${this.mainRowsSheetName}_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.excelService.downloadReport(
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            []
        )
            .map(file => { return { fileContent: file, fileName }; }));
    }

    //# send excel to email
    private onSendClick = (): void => {
        this.sendToEmail(data => this.excelService.sendReport(
            this.tab.itemInfo.sku,
            this.tab.itemInfo.warehouseCode,
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            [],
            this.mainRowsSheetName
        ));
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/simple-tab.component/simple-tab.component.ts